import { AnyType } from '@src/models/common';
import { IComponentChildrenProps } from '@src/models/props';
import React from 'react';

import { ErrorPage } from '../../pages/ErrorPage';

interface IProps extends IComponentChildrenProps {
  fallback: (error: Error, errorInfo: React.ErrorInfo) => void;

  //Отображаемый компонент в случае ошибки
  ErrorComponent?: React.ReactNode;
}

export class ErrorBoundary extends React.Component<IProps, AnyType> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.props.fallback(error, errorInfo);
    console.error({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return this.props.ErrorComponent || <ErrorPage errorType="unknown" />;
    }

    return this.props.children;
  }
}
